import React from 'react';
import { Row, Col } from 'antd';
import './ProposalItemLoader.scss';
import { proposalItem } from 'helpers/grid';

const Skeleton = (props) => <div className="skelton" {...props}></div>;

const ProposalItemLoader = () => {
  return (
    <Row className="item" justify="middle" align="top">
      <Col {...proposalItem.proposal} className="value value-proposal-title">
        <Skeleton style={{ width: '80%' }} />
      </Col>
      <Col {...proposalItem.client} className="value value-prospect-name">
        <Skeleton style={{ maxWidth: '70%' }} />
      </Col>
      <Col {...proposalItem.watched} className="value value-watched">
        <Skeleton />
      </Col>
      <Col {...proposalItem.opened} className="value value-opened">
        <Skeleton />
      </Col>
      <Col {...proposalItem.quote} className="value value-quote">
        <Skeleton />
      </Col>
      <Col {...proposalItem.status} className="value action-column value-status">
        <Skeleton />
      </Col>
      <Col {...proposalItem.action} />
    </Row>
  );
};

export default ProposalItemLoader;
